import React, { useContext, useState } from "react";
import ContentBox from "../components/ContentBox";
import HybridProImager from "../components/HybridProImager";
import { FontScaleContext } from "../App";
import { sulakeLogin } from "../services/api";

const SULAKE_CONFIG_BASE = {
    header: "Frankly Origins ProImager: Sulake Edition",
    icon: "/img/icons/icon_164.png",
    storageKey: "sulake_imager_meta_v1",
    scenesKey: "sulake_scenes_v3",
    activeSceneKey: "sulake_active_scene_id_v3",
    overrideUserId: "__sulake_shared__",
};

function Imager({ userData }) {
    const fontScale = useContext(FontScaleContext);
    const [sharedKey, setSharedKey] = useState(null);
    const [authed, setAuthed] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const result = await sulakeLogin(username, password);
            if (result?.success && result?.sharedKey) {
                setSharedKey(result.sharedKey);
                setAuthed(true);
            } else {
                setError(result?.message || "Incorrect username or password.");
            }
        } catch {
            setError("Login failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!authed) {
        return (
            <div style={{ zoom: 1 / fontScale }} className="min-h-[70vh] flex items-center justify-center">
                <div className="w-full max-w-sm">
                    <ContentBox header="Pro Imager" tint="#00D0F4" icon="/img/icons/icon_164.png">
                        <form onSubmit={handleLogin} className="flex flex-col gap-4 py-2">
                            {error && (
                                <p className="font-['Jersey_10'] text-sm text-red-600 uppercase tracking-wide">{error}</p>
                            )}
                            <div>
                                <label className="block font-['Jersey_10'] uppercase text-xs tracking-widest text-gray-500 mb-1">Username</label>
                                <input
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="w-full px-3 py-2 border border-black bg-white font-['Jersey_10'] text-sm focus:outline-none"
                                    autoComplete="off"
                                />
                            </div>
                            <div>
                                <label className="block font-['Jersey_10'] uppercase text-xs tracking-widest text-gray-500 mb-1">Password</label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full px-3 py-2 border border-black bg-white font-['Jersey_10'] text-sm focus:outline-none"
                                    autoComplete="off"
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="h-10 border border-black text-black font-['Jersey_10'] uppercase tracking-widest text-sm transition-colors disabled:opacity-50"
                                style={{ backgroundColor: "#00D0F4" }}
                            >
                                {loading ? "..." : "Enter"}
                            </button>
                        </form>
                    </ContentBox>
                </div>
            </div>
        );
    }

    return <div style={{ zoom: 1 / fontScale }}><HybridProImager userData={userData} config={{ ...SULAKE_CONFIG_BASE, sharedKey }} /></div>;
}

export default Imager;
